import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var getSizeWithinBounds = function getSizeWithinBounds(width, height, maxWidth, maxHeight, opts) {
  var options = _objectSpread({
    cover: false
  }, opts);

  if (!width || width <= 0 || !height || height <= 0) {
    return {
      width: 0,
      height: 0,
      ratio: 1
    };
  }

  var scaleWidth = Math.round(maxWidth || width) / width;
  var scaleHeight = Math.round(maxHeight || height) / height;
  var scale = options.cover ? Math.max(scaleWidth, scaleHeight) : Math.min(scaleWidth, scaleHeight);
  var computedWidth = Math.round(width * scale);
  var computedHeight = Math.round(height * scale);
  return {
    width: computedWidth,
    height: computedHeight,
    scale: scale
  };
};

export default getSizeWithinBounds;


//////////////////
// WEBPACK FOOTER
// /Users/dmp/Code/catbirdproductions.ca/node_modules/@folklore/size/es/getSizeWithinBounds.js
// module id = null
// module chunks = 